import type { Direction } from "../../../engine/direction";
import { BurstParticle } from "./burstParticle";

export class RockDebrisParticle extends BurstParticle {
	constructor(originX: number, originY: number, direction?: Direction) {
		super(
			originX,
			originY,
			{
				ttl: [300, 500],
				size: [0.55, 0.32],
				color: { r: 95, g: 55, b: 55 },
				speed: [1.5, 3.0],
				gravity: 6.0,
			},
			direction,
		);
	}
}
